window.addEventListener(
    'CookiebotOnConsentReady',
    function () {
        if (!Cookiebot.consent.marketing) return;

        var _hmt = _hmt || [];
        (function () {
            var hm = document.createElement('script');
            hm.src = 'https://hm.baidu.com/hm.js?58822b<99d8249edf1a2cf1c0a86945de';
            var s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(hm, s);
        })();

        !(function (g, d, t, e, v, n, s) {
            if (g.gdt) return;
            v = g.gdt = function () {
                v.tk ? v.tk.apply(v, arguments) : v.queue.push(arguments);
            };
            v.sv = '1.0';
            v.bt = 0;
            v.queue = [];
            n = d.createElement(t);
            n.async = !0;
            n.src = e;
            s = d.getElementsByTagName(t)[0];
            s.parentNode.insertBefore(n, s);
        })(
            window,
            document,
            'script',
            '//qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js',
        );
        gdt('init', '1108313281');
        gdt('track', 'PAGE_VIEW');

        window._agl = window._agl || [];
        (function () {
            _agl.push(['production', '_f7L2XwGXjyszb4d1e2oxPybgD']);
            (function () {
                var agl = document.createElement('script');
                agl.type = 'text/javascript';
                agl.async = true;
                agl.src =
                    'https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD';
                var s = document.getElementsByTagName('script')[0];
                s.parentNode.insertBefore(agl, s);
            })();
        })();
    },
    false
);
